const styles = (theme) => ({
  contactMessage: {
    marginTop: -theme.spacing.unit * 2.5,
  },
  buttonCustomClass: {
    marginLeft: theme.spacing.unit * 2,
  },
});

export default styles;
